// extracted by mini-css-extract-plugin
export default {"button":"Yk-z","reviewSort":"Zk-z"};